import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  list: {
    display: 'flex',
    padding: 0,
  },
  item: {
    padding: 0,
    width: 'auto',
    '&::after': {
      content: '""',
      width: 40,
      height: 1,
      backgroundColor: ({ light }) => (light ? theme.palette.colors.white : theme.palette.colors.darkBlue),
      margin: [0, theme.spacing(2)],
    },
    '&:last-child::after': {
      display: 'none',
    },
  },
  link: {
    color: ({ light }) => (light ? theme.palette.colors.white : theme.palette.colors.darkBlue),
    textTransform: 'uppercase',
    '&:hover': {
      color: ({ light }) => (light ? theme.palette.colors.white : theme.palette.colors.darkBlue),
    },
    fontSize: 14,
    [theme.breakpoints.up('xl')]: {
      fontSize: theme.spacing(2),
      lineHeight: '24px',
    },
  },
  active: {
    textShadow: ({ light }) => {
      const color = light ? theme.palette.colors.white : theme.palette.colors.darkBlue;
      return `1px 0 0 ${color}`;
    },
    transition: `text-shadow 0.8s`,
  },
}));



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Description/components/PageNav/useStyles.js